import { render, staticRenderFns } from "./homeClickIndex.vue?vue&type=template&id=015cd458&scoped=true"
import script from "./homeClickIndex.vue?vue&type=script&lang=js"
export * from "./homeClickIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015cd458",
  null
  
)

export default component.exports